// routes/_app.membership._index.tsx
import type { ClientLoaderFunctionArgs } from 'react-router'
import { createRedirect } from '~/utils/router/route'
import type { Route } from './+types/_app.membership._index'

const getClientModule = () => import('src/clientRoutes/_app.membership._index')

export const handle = { name: 'membership-shortcut' }

export function loader({ request }: Route.LoaderArgs) {
  return createRedirect(request, 'plans')
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  const { loader } = await getClientModule()
  return loader(args)
}

clientLoader.hydrate = true

export default function Page() {
  return null
}
